import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { FaSortUp, FaSortDown, FaSort } from 'react-icons/fa';
import moment from 'moment';

const COLUNAS = [
  { campo: 'codigo_usuario', label: 'Código', width: 80 },
  { campo: 'nome_completo', label: 'Nome Completo', width: 240 },
  { campo: 'data_hora_inclusao', label: 'Inclusão', width: 140 },
  { campo: 'data_hora_exclusao', label: 'Exclusão', width: 140 },
  { campo: 'status', label: 'Status', width: 100 },
];

const formatarData = (valor) => {
  if (!valor) return '—';
  return moment(valor).format('DD/MM/YYYY HH:mm');
};

const renderCelula = (coluna, item) => {
  if (coluna.campo === 'data_hora_inclusao') {
    return formatarData(item.data_hora_inclusao);
  }
  if (coluna.campo === 'data_hora_exclusao') {
    return formatarData(item.data_hora_exclusao);
  }
  if (coluna.campo === 'status') {
    const isAtivo = item.status === 'ATIVO';
    return (
      <span
        style={{
          color: isAtivo ? '#15D01A' : '#FF0000',
          fontWeight: 'bold',
        }}
      >
        {item.status}
      </span>
    );
  }
  return item[coluna.campo] != null ? item[coluna.campo] : '—';
};

const GridHistorico = ({ rows, ordenacao, onOrdenacao }) => {
  const iconeOrdenacao = (campo) => {
    if (!ordenacao || ordenacao.campo !== campo) {
      return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    }
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  const thStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  return (
    <Card className="shadow-sm">
      <Card.Header
        className="py-2"
        style={{ backgroundColor: '#0747a6', color: '#fff' }}
      >
        <strong>
          Histórico
          <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
            ({rows.length} {rows.length === 1 ? 'registro' : 'registros'})
          </span>
        </strong>
      </Card.Header>
      <Card.Body className="p-0">
        <div className="table-responsive">
          <Table striped bordered hover size="sm" className="mb-0">
            <thead>
              <tr>
                {COLUNAS.map((col) => (
                  <th
                    key={col.campo}
                    style={{ ...thStyle, width: col.width }}
                    onClick={() => onOrdenacao && onOrdenacao(col.campo)}
                  >
                    {col.label}
                    {iconeOrdenacao(col.campo)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={COLUNAS.length} className="text-center text-muted py-3">
                    Nenhum registro encontrado.
                  </td>
                </tr>
              ) : (
                rows.map((item) => (
                  <tr key={`${item.codigo_usuario}-${item.data_hora_inclusao}`}>
                    {COLUNAS.map((col) => (
                      <td key={col.campo}>{renderCelula(col, item)}</td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GridHistorico;
